const getRolesByUser = user => {
  return user['roleType']
}

const isAuthorizedByRole = (user, role) => {
  return getRolesByUser(user).find(item => item === role)
}
export { getRolesByUser, isAuthorizedByRole }
